import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { PersonQuery } from 'src/app/models/FilesRequest';
import { QrCodeComponent } from '../qr-code/qr-code.component';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-qr-code-dialog',
    standalone: true,
    imports: [DialogModule, TranslateModule, QrCodeComponent],
    templateUrl: './qr-code-dialog.component.html',
    styleUrls: ['./qr-code-dialog.component.scss']
})
export class QrCodeDialogComponent {
    position = input<"center" | "right" | "left" | "top" | "bottom" | "topleft" | "topright" | "bottomleft" | "bottomright">('bottom');
    draggable = input<boolean>(false);
    resizable = input<boolean>(false);
    dissmissableMask = input<boolean>(true);
    showId = input<boolean>(true);
    showLink = input<boolean>(true);
    isProd = environment.prodEnv;

    protected visible: boolean;
    protected personQuery: PersonQuery;

    open(personQuery: PersonQuery): void {
        this.personQuery = personQuery;
        this.visible = true;
    }
}
